import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import {IconsModule} from '../../icons/icons.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ErrorModule } from '../error/error.module';
import { InventoryKubernetesComponent } from './inventory-kubernetes.component';
import { CommonTableModule } from '../table/table.module';
import { SearchFilterModule } from '../search-filter/search-filter.module';


@NgModule({
  declarations: [InventoryKubernetesComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    CommonTableModule,
    SearchFilterModule
  ]
})
export class InventoryKubernetesModule { }